import React, { useState } from 'react';
import { useTeams } from '../hooks/useTeams';
import { useNavigate } from 'react-router-dom';
import {
    FaCloud, FaUserFriends, FaBook, FaFileAlt, FaComments,
    FaPlus, FaEdit
} from 'react-icons/fa';
import useTitle from '../hooks/useTitle';
import '../components/Dashboard/TeamsSection.css';

const TeamsPage = () => {
    useTitle('Teams');
    const { teams, loading, createTeam } = useTeams();
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [formData, setFormData] = useState({ name: '', description: '' });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrors({});

        try {
            const team = await createTeam(formData);
            setFormData({ name: '', description: '' });
            setShowCreateModal(false);
            navigate(`/teams/${team.id}`);
        } catch (err) {
            if (err.status === 422) {
                setErrors(err.errors);
            }
        }
    };

    const getTeamMembers = (team) => {
        // Get first 4 members for display
        const members = team.members || [];
        return members.slice(0, 4);
    };

    const getTotalMembers = (team) => {
        return team.members?.length || 0;
    };

    if (loading) {
        return <div className="teams-loading">Loading teams...</div>;
    }

    return (
        <div className="teams-container">
            <div className="teams-header-section">
                <h1 className="teams-title">Team</h1>
            </div>

            <div className="teams-grid">
                {/* Create New Team Card */}
                <div className="team-card create-card" onClick={() => setShowCreateModal(true)}>
                    <div className="create-icon">
                        <FaPlus />
                    </div>
                    <div className="create-label">Create New Team</div>
                </div>

                {/* Team Cards */}
                {teams.map((team) => (
                    <div
                        key={team.id}
                        className="team-card"
                        onClick={() => navigate(`/teams/${team.id}`)}
                    >
                        <div className="team-members-avatars">
                            {getTeamMembers(team).map((member, index) => (
                                <div key={index} className="member-avatar">
                                    {member.user?.avatar ? (
                                        <img src={member.user.avatar} alt={member.user?.name} />
                                    ) : (
                                        <div className="avatar-placeholder">
                                            {member.user?.name?.charAt(0) || 'U'}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        <div className="team-member-count">
                            Total members: {getTotalMembers(team)}
                        </div>

                        <div className="team-actions">
                            <div className="action-icon" title="Cloud Storage">
                                <FaCloud />
                            </div>
                            <div className="action-icon" title="Team Members">
                                <FaUserFriends />
                            </div>
                            <div className="action-icon" title="Edit Team">
                                <FaEdit />
                            </div>
                            <div className="action-icon" title="Documents">
                                <FaBook />
                            </div>
                            <div className="action-icon" title="Files">
                                <FaFileAlt />
                            </div>
                            <div className="action-icon" title="Messages">
                                <FaComments />
                            </div>
                        </div>

                        <div className="team-name">{team.name}</div>
                    </div>
                ))}
            </div>

            {/* Create Team Modal */}
            {showCreateModal && (
                <div className="modal-overlay" onClick={() => setShowCreateModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <h2>Create New Team</h2>
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label>Team Name *</label>
                                <input
                                    type="text"
                                    value={formData.name}
                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                    required
                                    placeholder="Enter team name"
                                />
                                {errors.name && <span className="error">{errors.name[0]}</span>}
                            </div>

                            <div className="form-group">
                                <label>Description</label>
                                <textarea
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    rows="3"
                                    placeholder="Enter team description (optional)"
                                />
                                {errors.description && <span className="error">{errors.description[0]}</span>}
                            </div>

                            <div className="modal-actions">
                                <button type="button" className="btn-secondary" onClick={() => setShowCreateModal(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className="btn-primary">
                                    Create Team
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TeamsPage;
